import { graphql, useStaticQuery } from "gatsby";

export const useFilteredGeographical = ({
  geographicals = [],
  hub = false,
  country = false,
  continent = false
} = {}) => {
  const { geographicalCollection } = useStaticQuery(graphql`
    {
      geographicalCollection: allWpGeographicals {
        geographicals: nodes {
          name
          id
          parentId
          slug
          uri
          description
          teamMembers {
            nodes {
              ...TeamMemberFragment
            }
          }
          culturalPractices {
            ...WpGeographicalsToCulturalPracticeConnectionFragment
          }
          weekendTrips {
            ...WpGeographicalsToWeekendTripsConnectionFragment
          }
          localAdventures {
            ...WpGeographicalsToLocalAdventuresConnectionFragment
          }
          furtherTravels {
            ...WpGeographicalsToFurtherTravelsConnectionFragment
          }
          locationPages {
            ...WpGeographicalsToLocationPagesConnectionFragment
          }
          programs {
            nodes {
              title
              uri
              featuredImage {
                node {
                  ...programGalleryData
                }
              }
              acfProgramsMeta {
                programTypes {
                  ... on WpProgramType {
                    id
                    title
                    slug
                  }
                }
              }
            }
          }
          baseTours {
            nodes {
              id
              title
              slug
              content
              acfBaseTour {
                accomodationTourContent
                accomodationTourImage {
                  ...iconImagesData
                }
                baseHighlightsBlocks {
                  baseHighlightsDesc
                  baseHighlightsTitle
                  baseHighlightsIcon {
                    ...iconImagesData
                  }
                  baseHighlightGallery {
                    ...iconImagesData
                  }
                }
                baseVideosGallery {
                  baseVideoTour
                }
                baseImageGallery {
                  ...iconImagesData
                }
                baseHighlightsGallery {
                  ...iconImagesData
                }
              }
              featuredImage {
                node {
                  ...programGalleryData
                }
              }
              taxonomyBaseHighlights {
                nodes {
                  name
                  acfBaseHighlight {
                    bhiIcon {
                      ...iconImagesData
                    }
                  }
                }
              }
            }
          }
          lifeOnBase {
            accomodationTourTitle
            baseTourTitle
            baseTour {
              accomodationTourText
              baseLifeText
              baseVideoGallery {
                baseVideo
              }
              baseImagesGallery {
                ...programGalleryData
              }
              baseHubLocation {
                ... on WpLocationPage {
                  id
                  uri
                  title
                  slug
                }
              }
            }
          }
          acfCountryExploration {
            gviExperiencesLabel
            gviExperiencesDescription
            gviExperiences {
              experienceTitle
              experienceOneliner
              experienceFeaturedImage {
                ...iconImagesData
              }
              experienceIcon {
                ...iconImagesData
              }
            }
          }
          hubTrainings {
            nodes {
              title
              content
            }
          }
          geographicalTaxonomy {
            facebookPage
            instagramPageLink
            linkedinPageLink
            tiktokPageLink
            twitterList
            whatsappLink
            youtubeChannelLink
            pageLink {
              ... on WpPage {
                id
                uri
                slug
                title
              }
            }
          }
        }
      }
    }
  `);

  const geographicalList = geographicalCollection?.geographicals?.filter(
    (geo) => geographicals.includes(geo.slug)
  );

  return geographicalList ?? [];
};
